import React, { Component } from 'react'
import PropTypes from 'prop-types'

const $ = window.$

class Select extends Component {
	componentDidMount() {
		this.initialiseWidgets()
	}

	componentDidUpdate() {
		this.initialiseWidgets()
	}

	getOptions = () => {
		return this.props.values.map((o) => {
			const attr = (() => {
				if (o.selected) {
					return { 'selected': 'selected' }
				}
				return {}
			})()
			return (<option value={ o.id ? o.id : o.label } { ...attr }> { o.label } </option>)
		})
	}
	initialiseWidgets = () => {
		const self = this
		$('select').on('change', function () {
			self.props.change($(this).val())
		}).material_select()
	}

	render() {
		if (this.props.disabled) {
			return (
				<div className='input-field col s12'>
					<select disabled>
						{ this.getOptions() }
					</select>
				</div>
			)
		}
		return (
			<div className='input-field col s12'>
				<select>
					{ this.getOptions() }
				</select>
			</div>
		)
	}

	componentWillUnmount() {
		$('select').material_select('destroy')
	}
}

Select.propTypes = {
	values: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		selected: PropTypes.bool
	})),
	title: PropTypes.string,
	change: PropTypes.function,
	disabled: PropTypes.bool
}
Select.defaultProps = {
	values: [{
		label: '',
		selected: false
	}],
	title: '',
	change: (''),
	disabled: false
}

export default Select



// WEBPACK FOOTER //
// ./src/components/select/Select.js